import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorState.css';

const ErrorState = ({
  type = 'warning', // 'warning', 'error', 'info'
  icon,
  title,
  message,
  details = [],
  diagnosis,
  reasons = [],
  actions = [],
  className = ''
}) => {
  const navigate = useNavigate();

  const handleAction = (action) => {
    if (typeof action === 'function') {
      action();
    } else if (typeof action === 'string') {
      navigate(action);
    } else if (action.onClick) {
      action.onClick();
    } else if (action.path) {
      navigate(action.path);
    }
  };

  const getIcon = () => {
    if (icon) return icon;
    switch (type) {
      case 'error':
        return '❌';
      case 'info':
        return 'ℹ️';
      case 'warning':
      default:
        return '⚠️';
    }
  };

  const getTypeClass = () => {
    switch (type) {
      case 'error':
        return 'error-state-error';
      case 'info':
        return 'error-state-info';
      case 'warning':
      default:
        return 'error-state-warning';
    }
  };

  return (
    <div className={`error-state ${getTypeClass()} ${className}`}>
      <div className="error-state-icon">{getIcon()}</div>
      <h3 className="error-state-title">{title}</h3>
      
      {message && (
        <p className="error-state-message">{message}</p>
      )}

      {details.length > 0 && (
        <div className="error-state-details">
          {details.map((detail, index) => (
            <div key={index} className="error-detail-item">
              {detail}
            </div>
          ))}
        </div>
      )}

      {diagnosis && (
        <div className="error-state-diagnosis">
          <p className="diagnosis-title">{diagnosis}</p>
          {reasons.length > 0 && (
            <ul className="diagnosis-reasons">
              {reasons.map((reason, index) => (
                <li key={index} className="diagnosis-reason-item">
                  {reason}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      {actions.length > 0 && (
        <div className="error-state-actions">
          {actions.map((action, index) => (
            <button
              key={index}
              className={`btn ${action.primary ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => handleAction(action)}
            >
              {action.label || action}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ErrorState;

